<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-b-modal.modalDialog
          variant="outline-primary"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <div class="card mb-1">
      <div class="card-body p-1">
        <b-row>
          <div class="col-12 col-md-3">
            <b-form-group
              label="Từ ngày"
              class="mb-0"
              label-for="start_time"
            >
              <flat-pickr
                v-model="start_time"
                class="form-control"
                :config="config_time"
                placeholder="dd-mm-yyyy"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group
              label="Đến ngày"
              class="mb-0"
              label-for="end_time"
            >
              <flat-pickr
                v-model="end_time"
                class="form-control"
                :config="config_time"
                placeholder="dd-mm-yyyy"
              />
            </b-form-group>
          </div>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Từ khóa"
              class="mb-0"
              label-for="name"
            >
              <b-input-group class="mb-0">
                <b-form-input
                  v-model="localSearchQuery"
                  class="d-inline-block"
                  placeholder="Tiêu đề thông báo"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    @click="doSearch"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- List -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refListTable"
          :items="dataItems"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="Không tìm thấy kết quả"
        >
          <template #cell(name)="data">
            <span
              v-if="data.item.status == 2"
              class="title"
            ><b>{{ data.item.name }}</b></span>
            <span
              v-else
              class="title"
              @click="edit(data.item)"
            ><b>{{ data.item.name }}</b></span>
          </template>
          <template #cell(status_text)="data">
            <span v-html="data.item.status_text" />
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="data.item.status != 2"
              class="btn-icon"
              variant="outline-primary"
              @click="edit(data.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              class="btn-icon ms-2"
              variant="outline-danger"
              @click="onDestroy(data.item)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of, }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal
      id="modalDialog"
      no-close-on-backdrop
      hide-footer
      size="lg"
      :title="dialog_title"
      @close="hidenModal"
    >
      <notification-form
        :data-edit="dataEdit"
        @updateList="handleDialog"
      />
    </b-modal>
  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BFormCheckbox,
  BPagination,
  BInputGroupAppend,
  BInputGroup,
  BFormGroup,
  BLink,
} from 'bootstrap-vue';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import vSelect from 'vue-select';
import NotificationForm from './NotificationForm.vue';

export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    NotificationForm,
    BFormGroup,
    BLink,
    vSelect,
    flatPickr,
  },
  data() {
    return {
      dialog_title: 'Thêm mới',
      dataEdit: {},
      itemView: {},
    };
  },
  setup() {
    const refListTable = ref(null);
    const tableColumns = [
      // { key: 'id', sortable: false, label: 'ID', thAttr: { width: '6%' } },
      { key: 'name', sortable: false, label: 'Tiêu đề' },
      {
        key: 'created_at',
        sortable: false,
        label: 'Ngày tạo',
        thAttr: { width: '10%' },
      },
      {
        key: 'start_date',
        sortable: false,
        label: 'Thời gian bắt đầu',
        thAttr: { width: '15%' },
      },
      {
        key: 'end_date',
        sortable: false,
        label: 'Thời gian kết thúc',
        thAttr: { width: '15%' },
      },
      {
        key: 'status_text',
        sortable: false,
        label: 'Trạng thái',
        thAttr: { width: '9%' },
      },
      {
        key: 'actions',
        label: 'Hành động',
        class: 'action',
        thAttr: { width: '6%' },
      },
    ];
    const perPage = ref(30);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const localSearchQuery = ref('');
    const loading = ref(true);
    const dataItems = ref([]);
    const start_time = ref('');
    const end_time = ref('');

    const fetchAll = () => {
      store
        .dispatch('notification/fetchAll', {
          keyword: localSearchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          start_date: start_time.value,
          end_date: end_time.value,
        })
        .then((response) => {
          loading.value = false;
          const result = response.data;

          if (result.code == 200) {
            dataItems.value = result.data;
            total.value = result.total;
          }
        });
    };
    fetchAll();
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });

    watch([currentPage, perPage, searchQuery], () => {
      refetchData();
    });

    const refetchData = () => {
      fetchAll();
    };

    const config_time = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      loading,
      dataItems,
      perPage,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      localSearchQuery,
      start_time,
      end_time,
      config_time,
    };
  },
  methods: {
    hidenModal() {
      this.$bvModal.hide('modalDialog');
      this.dataEdit = {};
    },
    hidenView() {
      this.$bvModal.hide('modalView');
      this.itemView = {};
    },
    handleDialog() {
      this.refetchData();
      this.$bvModal.hide('modalDialog');
    },
    edit(item) {
      this.dataEdit = item;
      this.dialog_title = 'Cập nhật';
      this.$bvModal.show('modalDialog');
    },
    showView(item) {
      // if (item.type == 'audio') {
      //   this.modal_title = 'Nghe phát thanh';
      // }
      // this.itemView = item;
      // this.$bvModal.show('modalView');
    },
    doSearch() {
      this.searchQuery = this.localSearchQuery;
      if (this.start_time && this.start_time > this.end_time) {
        showToast('Đến ngày phải lớn hơn từ ngày');
        return false;
      }
      this.refetchData();
    },
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa thông báo này không?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const { id } = item;
          store.dispatch('notification/destroy', id).then((response) => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.refetchData();
            } else {
              showToast(result.message);
            }
          });
        }
      });
    },
    updateStatus(item) {
      const { id } = item;
      const card_type = 'channel';
      store.dispatch('channel/status', { id, card_type }).then((response) => {
        const result = response.data;
        if (result.code === 200) {
          showToast(result.message, { variant: 'success' });
          this.refetchData();
        } else {
          showToast(result.message, { variant: msg_class });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
